export const keyOfForm = [
  'code', // "string",
  'name', // "string",
  'address', // "string",
  'phone', // "string",
  'fax', // "string",
  'contactPerson', // "string",
  'contactPosition', // "string",
  'replyEmail', // true,
  'status', // 0,
  'isActive', // true,
];
export default (data) => {
  return keyOfForm.map((item) => {
    return {
      name: [item],
      value: data[item] || null,
      errors: [],
    };
  });
};
